import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";

// Shared chrome for "a manager acts on one trainee's training item" modals
// (grading a form, recording a manager input, ...). Keeps the header/footer and
// layout identical across surfaces (Records queue + inline in the trainee's
// training). Each modal supplies its own body via children and a single primary
// action; Cancel is always provided.
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 640,
  maxHeight: "90vh",
  bgcolor: "background.paper",
  borderRadius: "16px",
  boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  overflowY: "auto",
  border: "none",
};

function TraineeActionModal({
  open,
  onClose,
  title,
  subtitle,
  children,
  primaryLabel = "Save",
  onPrimary,
  primaryDisabled = false,
  primaryBusy = false,
  busyLabel = "Saving…",
}) {
  return (
    <Modal open={open} onClose={onClose} disableEnforceFocus>
      <Box sx={style}>
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 z-10 rounded-t-2xl">
          <div className="flex items-center justify-between gap-3">
            <div className="min-w-0">
              <h3 className="text-xl font-bold text-slate-900 truncate">{title}</h3>
              {subtitle && (
                <p className="text-sm text-slate-600 truncate">{subtitle}</p>
              )}
            </div>
            <button
              className="w-8 h-8 rounded-lg hover:bg-gray-100 flex items-center justify-center text-gray-500 shrink-0"
              onClick={onClose}
            >
              <CloseIcon />
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="px-6 py-5">
          {children}

          {/* Footer */}
          <div className="mt-6 flex items-center justify-end gap-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-slate-600 hover:text-slate-800"
            >
              Cancel
            </button>
            <button
              onClick={onPrimary}
              disabled={primaryDisabled || primaryBusy}
              className="inline-flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-medium text-white bg-violet-600 hover:bg-violet-700 disabled:opacity-40 disabled:cursor-not-allowed"
            >
              {primaryBusy ? busyLabel : primaryLabel}
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default TraineeActionModal;
